import { ButtonLink, ActionLink } from "./Button";
import { Container } from "./Container";
import { site } from "@/content/site";

export function GlobalCTA() {
  return (
    <section className="bg-brand-950 py-16 text-white md:py-20" aria-labelledby="global-cta">
      <Container className="grid items-center gap-8 lg:grid-cols-[1.2fr_auto]">
        <div>
          <p className="text-sm font-bold uppercase tracking-wide text-mint">Next step</p>
          <h2 id="global-cta" className="mt-3 text-3xl font-bold md:text-4xl">
            See a mission built from your own brief
          </h2>
          <p className="mt-4 max-w-2xl text-brand-100">
            Bring a product, goal, or recent creative problem. We will show how Agentic Plus
            organizes evidence, creates a reviewable brief, and keeps approvals connected to each
            version.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
          <ButtonLink to="/contact" variant="light">
            Request a demo
          </ButtonLink>
          <ActionLink
            href={`mailto:${site.email}?subject=Agentic%20Plus%20question`}
            variant="secondary"
            className="border-white/50 text-white hover:bg-white/10"
          >
            Email the team
          </ActionLink>
        </div>
      </Container>
    </section>
  );
}
